module.exports = __webpack_public_path__ + "img/sun-01.004404ba.svg";